export const isSafari = (): boolean => {
    const { userAgent } = navigator;
    return userAgent.includes('Safari') && !userAgent.includes('Chrome') && !userAgent.includes('Chromium');
};

export const isIosWebView = () => {
    return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent);
};
